<template>
  <div id="bidSetTem">
    <el-row class="content" style="margin-top: -45px;padding: 0;background:none;">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="contentTitle" style="display: flow-root;position: absolute;right: 2px;top: 13px;z-index: 99;">
          <el-button v-show="editBtn" type="primary" icon="el-icon-edit " style="vertical-align: top;float: right;margin-left: 10px;" @click="edit" />
          <el-button v-show="closeBtn" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="close" /><!--取消-->
          <el-button v-show="viewBtn=='close'" type="primary" icon="el-icon-close" style="vertical-align: top;float: right;" @click="clickSet('close')" /><!--收起配置-->
          <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" :disabled="disabledEdit" @click="clickSet('open')" /><!--配置-->
          <!-- <el-button v-show="viewBtn=='open'" type="primary" icon="el-icon-setting" style="vertical-align: top;float: right;" @click="clickSet('open')" />配置 -->
        </p>
        <!-- 配置-查看 -->
        <div v-show="viewTable" class="contentWrap" style="padding:0;margin-top: 10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;">{{ item.name }}</td>
                  <td style="text-align: left;">
                    <p v-if="item.key=='inverterType'">{{ inverterType }}</p>
                    <el-switch v-if="item.key=='reset'" v-model="tableEditObj.reset" :disabled="true" active-text="ON" inactive-text="OFF" @change="resetOnOff(tableEditObj.reset)" />
                    <el-select v-if="item.key=='lowVProtect'" v-model="tableEditObj.lowVProtect" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in lowVProtectOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='lowVWarn'" v-model="tableEditObj.lowVWarn" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in lowVWarnOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='lowVReset'" v-model="tableEditObj.lowVReset" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in lowVResetOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='inverterStatu'" v-model="tableEditObj.inverterStatu" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in inverterStatuOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='savePower'" v-model="tableEditObj.savePower" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in saveElectricityOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <!-- <el-switch v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
                      <el-switch v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" /> -->
                    <el-radio v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" label="1" :disabled="true">ON</el-radio>
                    <el-radio v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" label="2" :disabled="true">OFF</el-radio>
                    <el-radio v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" label="1" :disabled="true">ON</el-radio>
                    <el-radio v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" label="2" :disabled="true">OFF</el-radio>

                    <el-select v-if="item.key=='batteryType'" v-model="tableEditObj.batteryType" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='chargeA'" v-model="tableEditObj.chargeA" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in chargeAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='absV'" v-model="tableEditObj.absV" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in absVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='floatA'" v-model="tableEditObj.floatA" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in floatAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='floatV'" v-model="tableEditObj.floatV" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in floatVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='rechargeV'" v-model="tableEditObj.rechargeV" class="editTableTd" placeholder="Select" :disabled="true">
                      <el-option v-for="option in rechargeVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="1" :disabled="true">Low</el-radio>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="2" :disabled="true">Nor</el-radio>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="3" :disabled="true">HI</el-radio>

                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="2" :disabled="true">30 A</el-radio>
                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="1" :disabled="true">20 A</el-radio>
                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="3" :disabled="true">15 A</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <!-- <tr>
                    <td colspan="3">
                      <el-button type="primary" style="vertical-align: top;margin-right: 20px;float: right;" @click="tableSubmit('charging')">提交</el-button>
                    </td>
                  </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <!-- 配置-编辑 -->
        <div v-show="editTable" class="contentWrap" style="padding:0;margin-top:10px;">
          <div>
            <p class="btnSpace" />
            <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #537ca3;font-size:14px;">
              <thead>
                <tr>
                  <th style="width:30%">Options</th>
                  <th style="width:30%">Value</th>
                  <th style="width:40%">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tableData" :key="index">
                  <td style="text-align: center;">{{ item.name }}</td>
                  <td style="text-align: left;">
                    <p v-if="item.key=='inverterType'">{{ inverterType }}</p>
                    <el-switch v-if="item.key=='reset'" v-model="tableEditObj.reset" active-text="ON" inactive-text="OFF" @change="resetOnOff(tableEditObj.reset)" />
                    <el-select v-if="item.key=='lowVProtect'" v-model="tableEditObj.lowVProtect" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in lowVProtectOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='lowVWarn'" v-model="tableEditObj.lowVWarn" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in lowVWarnOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='lowVReset'" v-model="tableEditObj.lowVReset" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in lowVResetOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='inverterStatu'" v-model="tableEditObj.inverterStatu" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in inverterStatuOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='savePower'" v-model="tableEditObj.savePower" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in saveElectricityOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <!-- <el-switch v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
                      <el-switch v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" /> -->
                    <el-radio v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" label="1">ON</el-radio>
                    <el-radio v-if="item.key=='buzzerOnOff'" v-model="tableEditObj.buzzerOnOff" label="2">OFF</el-radio>
                    <el-radio v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" label="1">ON</el-radio>
                    <el-radio v-if="item.key=='chargeOnOff'" v-model="tableEditObj.chargeOnOff" label="2">OFF</el-radio>

                    <el-select v-if="item.key=='batteryType'" v-model="tableEditObj.batteryType" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='chargeA'" v-model="tableEditObj.chargeA" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in chargeAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='absV'" v-model="tableEditObj.absV" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in absVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='floatA'" v-model="tableEditObj.floatA" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in floatAOptions" :key="option.value" :label="option.label" :value="option.value" />
                    </el-select>
                    <el-select v-if="item.key=='floatV'" v-model="tableEditObj.floatV" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in floatVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-select v-if="item.key=='rechargeV'" v-model="tableEditObj.rechargeV" class="editTableTd" placeholder="Select">
                      <el-option v-for="option in rechargeVOptions" :key="option.value" :label="option.label" :value="option.label" />
                    </el-select>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="1">Low</el-radio>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="2">Nor</el-radio>
                    <el-radio v-if="item.key=='batteryTem'" v-model="tableEditObj.batteryTem" label="3">HI</el-radio>

                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="2">30 A</el-radio>
                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="1">20 A</el-radio>
                    <el-radio v-if="item.key=='currentLimit'" v-model="tableEditObj.currentLimit" label="3">15 A</el-radio>
                  </td>
                  <td style="text-align: left;padding:10px 0;">{{ item.remark }}</td>
                </tr>
                <tr>
                  <td colspan="3" style="height: 40px;">
                    <el-button type="primary" style="vertical-align: top;margin-right: 2px;float: right;" @click="tableSubmit('charging')">{{ $t('button.Submit') }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setIvtCfg, getIvtCfg } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'Bidirectional',
  components: {
  },
  props: {
    inverterType1: {
      type: String,
      default: ''
    },
    online: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bidOnline: false,
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      inverterType: this.inverterType1,
      tableDataAll: [
        { key: 'inverterType', isShow: true, name: 'Model', nameZ: '逆变器型号', remark: '' },
        { key: 'reset', isShow: true, name: 'Reset Config', nameZ: '恢复默认', remark: 'Use default settings if turn on.' },
        { key: 'lowVProtect', isShow: true, name: 'Battery Low Voltage Disconnect', nameZ: '电池低压保护值', remark: 'Low voltage protection threshold. All function will be off if lower than this value.Range 10.5 - 12.0 (0.1V step)' },
        { key: 'lowVWarn', isShow: true, name: 'Battery Low Voltage Alarm', nameZ: '电池低压警告值', remark: 'Low voltage warning threshold. Warning will be triggered if lower than this value.Range 11.0 - 12.5 (0.1V step),min 0.5V above low voltage protection threshold.' },
        { key: 'lowVReset', isShow: true, name: 'Battery Low Voltage Recovery', nameZ: '电池低压保护恢复电压值', remark: 'Low voltage recover threshold. Function will be resumed if voltage is higher than this value, after a low voltage protection. Range 11.5 - 13.0 (0.1V step), min 0.5V above low voltage warning threshold.' },
        { key: 'inverterStatu', isShow: true, name: 'INV Status', nameZ: '逆变器状态设置', remark: ' Operation mode: OFF=Inverter function is disable.No AC backup when AC blackout.ON=Use as inverter only. No by-pass functions.ABU=Auto backup. Inverter automatically turns ON when AC blackout.MBU=Manual backup. Inverter has to be manually turned ON when AC blackout.' },
        { key: 'savePower', isShow: true, name: 'Load Sense', nameZ: '省电模式设置', remark: 'Disable/Enable the load sense function. If enabled, AC output will alternate between ON/OFF in a few seconds  if loading is less than the set value.' },
        { key: 'buzzerOnOff', isShow: true, name: 'Alarm', nameZ: '蜂鸣器开关', remark: 'Disable/enable the buzzer during an alarm.' },
        { key: 'chargeOnOff', isShow: true, name: 'Charger', nameZ: '充电开关', remark: 'ON:Charger is enabled. Charge battery when AC input is available.OFF:Charger is disabled. No battery charging when AC input is available.' },
        { key: 'batteryType', isShow: true, name: 'Battery Type', nameZ: '电池类型', remark: 'Select battery type, relevant information will be shown.Type of battery include: GEL,AGM,FLOODED,LITHIUM,PGM' },
        { key: 'chargeA', isShow: true, name: 'Bulk Current', nameZ: '充电电流', remark: 'Select the bulk stage charging current,100A, 80.0A, 60.0A, 40.0A, 20.0A, 5.0A' },
        { key: 'absV', isShow: true, name: 'Absorption  Voltage', nameZ: 'ABS电压', remark: 'Select the absorption voltage.Range 13.8 - 14.8 (0.1V step). ' },
        { key: 'floatA', isShow: true, name: 'Float Current', nameZ: '浮充电流', remark: 'Select the float stage charging current,20.0A, 15.0A, 10.0A, 5.0A, 2.0A, 1.0A' },
        { key: 'floatV', isShow: true, name: 'Float Voltage', nameZ: '浮充电压', remark: 'Select the float stage charging voltage,Range 13.0 - 14.0 (0.1V step), min 0.4V below absorption voltage.' },
        { key: 'rechargeV', isShow: true, name: 'Recharge Voltage', nameZ: '重充电压', remark: 'Select the recharge charging voltage,Range 12.8 - 14.0V (0.1V step), min 0.4V below float voltage.' },
        { key: 'batteryTem', isShow: true, name: 'Battery Temperature', nameZ: '电池温度', remark: 'Temperature compensation. Low: used when ambient temp.<5℃ Nor:used when 5<=ambient temp.<=30℃ HI: used when ambient temp>30℃ If battery temperature sensor is used, it will adjust the compensation automatically.' },
        { key: 'currentLimit', isShow: true, name: 'Circuit Breaker', nameZ: '市电输入限流', remark: 'Max AC input current,15.0A, 20.0A, 30.0A' }
      ],
      tableEditObj: {
        reset: false,
        lowVProtect: '',
        lowVWarn: '',
        lowVReset: '',
        inverterStatu: '',
        savePower: '',
        buzzerOnOff: '',
        chargeOnOff: '',
        batteryType: '',
        chargeA: '',
        absV: '',
        floatA: '',
        floatV: '',
        rechargeV: '',
        batteryTem: '',
        currentLimit: ''
      },
      lowVProtectOptions: [
        {	label: '10.5 V',	value: '1'	},
        {	label: '10.6 V',	value: '2'	},
        {	label: '10.7 V',	value: '3'	},
        {	label: '10.8 V',	value: '4'	},
        {	label: '10.9 V',	value: '5'	},
        {	label: '11.0 V',	value: '6'	},
        {	label: '11.1 V',	value: '7'	},
        {	label: '11.2 V',	value: '8'	},
        {	label: '11.3 V',	value: '9'	},
        {	label: '11.4 V',	value: '10'	},
        {	label: '11.5 V',	value: '11'	},
        {	label: '11.6 V',	value: '12'	},
        {	label: '11.7 V',	value: '13'	},
        {	label: '11.8 V',	value: '14'	},
        {	label: '11.9 V',	value: '15'	},
        {	label: '12.0 V',	value: '16'	}
      ],
      lowVWarnOptions: [
        {	label: '11.0 V',	value: '1'	},
        {	label: '11.1 V',	value: '2'	},
        {	label: '11.2 V',	value: '3'	},
        {	label: '11.3 V',	value: '4'	},
        {	label: '11.4 V',	value: '5'	},
        {	label: '11.5 V',	value: '6'	},
        {	label: '11.6 V',	value: '7'	},
        {	label: '11.7 V',	value: '8'	},
        {	label: '11.8 V',	value: '9'	},
        {	label: '11.9 V',	value: '10'	},
        {	label: '12.0 V',	value: '11'	},
        {	label: '12.1 V',	value: '12'	},
        {	label: '12.2 V',	value: '13'	},
        {	label: '12.3 V',	value: '14'	},
        {	label: '12.4 V',	value: '15'	},
        {	label: '12.5 V',	value: '16'	}
      ],
      lowVResetOptions: [
        {	label: '11.5 V',	value: '1'	},
        {	label: '11.6 V',	value: '2'	},
        {	label: '11.7 V',	value: '3'	},
        {	label: '11.8 V',	value: '4'	},
        {	label: '11.9 V',	value: '5'	},
        {	label: '12.0 V',	value: '6'	},
        {	label: '12.1 V',	value: '7'	},
        {	label: '12.2 V',	value: '8'	},
        {	label: '12.3 V',	value: '9'	},
        {	label: '12.4 V',	value: '10'	},
        {	label: '12.5 V',	value: '11'	},
        {	label: '12.6 V',	value: '12'	},
        {	label: '12.7 V',	value: '13'	},
        {	label: '12.8 V',	value: '14'	},
        {	label: '12.9 V',	value: '15'	},
        {	label: '13.0 V',	value: '16'	}
      ],
      inverterStatuOptions: [
        {	label: 'ON',	value: '1'	},
        {	label: 'Abu',	value: '2'	},
        {	label: 'Mbu',	value: '3'	},
        {	label: 'OFF',	value: '4'	}
      ],
      saveElectricityOptions: [
        {	label: '10 W',	value: '1'	},
        {	label: '15 W',	value: '2'	},
        {	label: '20 W',	value: '3'	},
        {	label: '25 W',	value: '4'	},
        {	label: 'OFF',	value: '5'	}
      ],
      batteryTypeOptions: [
        {	label: 'GEL',	value: '1'	},
        {	label: 'AGM',	value: '2'	},
        {	label: 'FLOODE',	value: '3'	},
        {	label: 'Lithium',	value: '4'	},
        {	label: 'Program',	value: '5'	}
        // {	label: 'PSY',	value: '6'	}
      ],
      chargeAOptions: [
        {	label: '100 A',	value: '5'	},
        {	label: '80 A',	value: '1'	},
        {	label: '60 A',	value: '2'	},
        {	label: '40 A',	value: '3'	},
        {	label: '20 A',	value: '4'	}
      ],
      absVOptions: [
        {	label: '13.8 V',	value: '1'	},
        {	label: '13.9 V',	value: '2'	},
        {	label: '14.0 V',	value: '3'	},
        {	label: '14.1 V',	value: '4'	},
        {	label: '14.2 V',	value: '5'	},
        {	label: '14.3 V',	value: '6'	},
        {	label: '14.4 V',	value: '7'	},
        {	label: '14.5 V',	value: '8'	},
        {	label: '14.6 V',	value: '9'	},
        {	label: '14.7 V',	value: '10'	},
        {	label: '14.8 V',	value: '11'	}

      ],
      floatAOptions: [
        {	label: '20 A',	value: '5'	},
        {	label: '15 A',	value: '1'	},
        {	label: '10 A',	value: '2'	},
        {	label: '5 A',	value: '3'	},
        {	label: '2 A',	value: '4'	}
      ],
      floatVOptions: [
        {	label: '13.0 V',	value: '1'	},
        {	label: '13.1 V',	value: '2'	},
        {	label: '13.2 V',	value: '3'	},
        {	label: '13.3 V',	value: '4'	},
        {	label: '13.4 V',	value: '5'	},
        {	label: '13.5 V',	value: '6'	},
        {	label: '13.6 V',	value: '7'	},
        {	label: '13.7 V',	value: '8'	},
        {	label: '13.8 V',	value: '9'	},
        {	label: '13.9 V',	value: '10'	},
        {	label: '14.0 V',	value: '11'	}
      ],
      rechargeVOptions: [
        {	label: '12.8 V',	value: '1'	},
        {	label: '12.9 V',	value: '2'	},
        {	label: '13.0 V',	value: '3'	},
        {	label: '13.1 V',	value: '4'	},
        {	label: '13.2 V',	value: '5'	},
        {	label: '13.3 V',	value: '6'	},
        {	label: '13.4 V',	value: '7'	},
        {	label: '13.5 V',	value: '8'	},
        {	label: '13.6 V',	value: '9'	},
        {	label: '13.7 V',	value: '10'	},
        {	label: '13.8 V',	value: '11'	},
        {	label: '13.9 V',	value: '12'	},
        {	label: '14.0 V',	value: '13'	}
      ],
      tableInvMqttData: null,
      disabledEdit: true,
      inverterTypeArr: [
        { value: '0', label: 'GPIC1230100-KS-01' },
        { value: '1', label: 'GPIC1220080-KS-01' },
        { value: '2', label: 'GPIC1230100I-KS-01' },
        { value: '3', label: 'GPIC1220080I-KS-01' },
        { value: '4', label: 'GPIC2430050-KS-01' },
        { value: '5', label: 'GPIC2420040-KS-01' },
        { value: '6', label: 'GPIC2430050I-KS-01' },
        { value: '7', label: 'GPIC2420040I-KS-01' },
        { value: '10', label: 'GPIC1225050-KS-01' },
        { value: '11', label: 'GPIC1225050I-KS-01' },
        { value: '12', label: 'GPIC2425050-KS-01' },
        { value: '13', label: 'GPIC2425050I-KS-01' },
        { value: '14', label: 'GPIC1230100-KS-01' }
      ]
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    },
    // online(newValue, oldValue) {
    //   console.log('双向逆变器online---', newValue)
    //   this.bidOnline = newValue
    //   if (newValue) this.viewBtn == 'open'
    // },
    online: {
      handler(newValue, oldValue) {
        // console.log('双向逆变器online---', newValue)
        this.bidOnline = newValue
        if (newValue) { this.disabledEdit = false } else { this.disabledEdit = true }
      },
      deep: true,
      immediate: true
    },
    tableEditObjType: {// 型号
      handler(newValue, oldValue) {
        console.log(newValue)
        if (newValue.indexOf('10') > -1) {
          this.GAFAOptions = [
            {
              value: '2',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            }
          ]
        } else if (newValue.indexOf('30') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 1.5A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 6A' }
              ]
            }
          ]
        } else if (newValue.indexOf('50') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 15A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '5',
              label: 'Bulk 25A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 5A' }
              ]
            },
            {
              value: '6',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 6A' }
              ]
            },
            {
              value: '7',
              label: 'Bulk 35A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 5A' },
                { value: '3', label: 'Float 7A' }
              ]
            },
            {
              value: '8',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '9',
              label: 'Bulk 45A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 9A' }
              ]
            },
            {
              value: '10',
              label: 'Bulk 50A',
              children: [
                { value: '1', label: 'Float 5A' },
                { value: '2', label: 'Float 7A' },
                { value: '3', label: 'Float 10A' }
              ]
            }
          ]
        }
        if (newValue.indexOf('12') > -1) {
          this.proABSVOptions = [
            { label: '13.8 V', value: '1' },
            { label: '13.9 V', value: '2' },
            { label: '14.0 V', value: '3' },
            { label: '14.1 V', value: '4' },
            { label: '14.2 V', value: '5' },
            { label: '14.3 V', value: '6' },
            { label: '14.4 V', value: '7' },
            { label: '14.5 V', value: '8' },
            { label: '14.6 V', value: '9' },
            { label: '14.7 V', value: '10' },
            { label: '14.8 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '13.0 V', value: '1' },
            { label: '13.1 V', value: '2' },
            { label: '13.2 V', value: '3' },
            { label: '13.3 V', value: '4' },
            { label: '13.4 V', value: '5' },
            { label: '13.5 V', value: '6' },
            { label: '13.6 V', value: '7' },
            { label: '13.7 V', value: '8' },
            { label: '13.8 V', value: '9' }
          ]
          this.LithiumVOptions = [
            { label: '13.9 V', value: '1' },
            { label: '14.0 V', value: '2' },
            { label: '14.1 V', value: '3' },
            { label: '14.2 V', value: '4' },
            { label: '14.3 V', value: '5' },
            { label: '14.4 V', value: '6' },
            { label: '14.5 V', value: '7' },
            { label: '14.6 V', value: '8' }
          ]
          this.LithiumFloatVOptions = [
            {	label: '13.5	V',	value: '1'	},
            {	label: '13.6	V',	value: '2'	},
            {	label: '13.7	V',	value: '3'	},
            {	label: '13.8	V',	value: '4'	},
            {	label: '13.9	V',	value: '5'	},
            {	label: '14.0	V',	value: '6'	},
            {	label: '14.1	V',	value: '7'	},
            {	label: '14.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('24') > -1) {
          this.proABSVOptions = [
            { label: '27.6 V', value: '1' },
            { label: '27.8 V', value: '2' },
            { label: '28.0 V', value: '3' },
            { label: '28.2 V', value: '4' },
            { label: '28.4 V', value: '5' },
            { label: '28.6 V', value: '6' },
            { label: '28.8 V', value: '7' },
            { label: '29.0 V', value: '8' },
            { label: '29.2 V', value: '9' },
            { label: '29.4 V', value: '10' },
            { label: '29.6 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '26.0 V', value: '1' },
            { label: '26.2 V', value: '2' },
            { label: '26.4 V', value: '3' },
            { label: '26.6 V', value: '4' },
            { label: '26.8 V', value: '5' },
            { label: '27.0 V', value: '6' },
            { label: '27.2 V', value: '7' },
            { label: '27.4 V', value: '8' },
            { label: '27.6 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '27.8	V',	value: '1'	},
            {	label: '28.0	V',	value: '2'	},
            {	label: '28.2	V',	value: '3'	},
            {	label: '28.4	V',	value: '4'	},
            {	label: '28.6	V',	value: '5'	},
            {	label: '28.8	V',	value: '6'	},
            {	label: '29.0	V',	value: '7'	},
            {	label: '29.2	V',	value: '8'	}
          ]
          this.LithiumFloatVOptions = [
            {	label: '27.0	V',	value: '2'	},
            {	label: '27.2	V',	value: '3'	},
            {	label: '27.4	V',	value: '4'	},
            {	label: '27.6	V',	value: '5'	},
            {	label: '27.8	V',	value: '6'	},
            {	label: '28.0	V',	value: '7'	},
            {	label: '28.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('48') > -1) {
          this.proABSVOptions = [
            { label: '55.2 V', value: '1' },
            { label: '55.6 V', value: '2' },
            { label: '56.0 V', value: '3' },
            { label: '56.4 V', value: '4' },
            { label: '56.8 V', value: '5' },
            { label: '57.2 V', value: '6' },
            { label: '57.6 V', value: '7' },
            { label: '58.0 V', value: '8' },
            { label: '58.4 V', value: '9' },
            { label: '58.8 V', value: '10' },
            { label: '59.2 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '52.0 V', value: '1' },
            { label: '52.4 V', value: '2' },
            { label: '52.8 V', value: '3' },
            { label: '53.2 V', value: '4' },
            { label: '53.6 V', value: '5' },
            { label: '54.0 V', value: '6' },
            { label: '54.4 V', value: '7' },
            { label: '54.8 V', value: '8' },
            { label: '55.2 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '55.6	V',	value: '1'	},
            {	label: '56.0	V',	value: '2'	},
            {	label: '56.4	V',	value: '3'	},
            {	label: '56.8	V',	value: '4'	},
            {	label: '57.2	V',	value: '5'	},
            {	label: '57.6	V',	value: '6'	},
            {	label: '58.0	V',	value: '7'	},
            {	label: '58.4	V',	value: '8'	}

          ]
          this.LithiumFloatVOptions = [
            {	label: '54.0	V',	value: '1'	},
            {	label: '54.4	V',	value: '2'	},
            {	label: '54.8	V',	value: '3'	},
            {	label: '55.2	V',	value: '4'	},
            {	label: '55.6	V',	value: '5'	},
            {	label: '56.0	V',	value: '6'	},
            {	label: '56.4	V',	value: '7'	},
            {	label: '56.8	V',	value: '8'	}
          ]
        }
      },
      deep: true
    },
    tableEditObjBatteryType: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 2 || newValue == 3) { // GEL/AGM/Flooded
            if (v.key == 'GAFA' || v.key == 'GAFCharge' || v.key == 'GAFTem') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 4) { // Lithium
            if (v.key == 'LithiumV' || v.key == 'LithiumFloatV' || v.key == 'LithiumA') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 5) { // Program
            if (v.key == 'proABSV' || v.key == 'proV' || v.key == 'proA' || v.key == 'proCharge') { v.isShow = true } else { v.isShow = false }
          }
          if (v.key == 'type' || v.key == 'batteryType' || v.key == 'eqStatus' || v.key == 'autoStatus') { v.isShow = true }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    }
  },
  mounted() {
    // getIvtCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
  },
  created() {
  },
  destroyed: function() {
  },
  methods: {
    resetOnOff(value) {
      if (!value) {
        this.tableDataAll.forEach(v => {
          v.isShow = true
        })
      } else { // 打开
        this.tableDataAll.forEach(v => {
          v.isShow = false
          if (v.key == 'inverterType' || v.key == 'reset')v.isShow = true
        })
      }
    },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        getIvtCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    change(e) {
      this.$forceUpdate()
    },
    tableSubmit() {
      var param = {
        'batType': this.tableEditObj.batteryType,
        'vol_ABS': parseFloat(this.tableEditObj.absV) * 100,
        'vol_float': parseFloat(this.tableEditObj.floatV) * 100,
        'chargeKey': this.tableEditObj.chargeOnOff,
        'chargeCurr': this.tableEditObj.chargeA,
        'currFloat': this.tableEditObj.floatA,
        'rechargeVol': parseFloat(this.tableEditObj.rechargeV) * 100,
        'bTM': this.tableEditObj.batteryTem,
        'cbr': this.tableEditObj.currentLimit,
        // 'defaults': this.tableEditObj.reset,
        'batLowVolRst': parseFloat(this.tableEditObj.lowVReset) * 100,
        // 'mode': this.inverterType,
        'mode': 0,
        'mcuId': this.$route.query.mcuId,
        'batLowVolAlarm': parseFloat(this.tableEditObj.lowVWarn) * 100,
        'batLowVolProtect': parseFloat(this.tableEditObj.lowVProtect) * 100,
        // 'batOverVolProtect': this.tableEditObj.batteryType,
        'inverterStatus': this.tableEditObj.inverterStatu,
        'buzzerStatus': this.tableEditObj.buzzerOnOff,
        'lowPowerMode': this.tableEditObj.savePower
        // 'inverterOutVol': this.tableEditObj.batteryType,
        // 'inverterOutCur': this.tableEditObj.batteryType,
        // 'outputPower': 0
      }
      for (var i in param) {
        if (!param[i]) delete param[i]
      }
      if (this.tableEditObj.reset) { param.defaults = 1 } else { param.defaults = 0 }
      this.$confirm('submit change?', '', {// '是否提交修改？'
        confirmButtonText: 'Confirm', // '确定',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        setIvtCfg(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
            this.viewTable = this.editBtn = true
            this.editTable = this.closeBtn = false
            this.viewBtn = 'close'
          }
        })
      }).catch(() => {
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          if (!this.yhubmqtt.mCan) return
          if (this.yhubmqtt.mCan.payload == 'mGetCANCfgData') {
            if (this.yhubmqtt.mCan.mGetCANCfgData.cfgData) {
              this.tableInvMqttData = this.yhubmqtt.mCan.mGetCANCfgData.cfgData
              if (!this.tableInvMqttData) {
                return
              }
              console.log('this.tableInvMqttData-双向cfg--', this.tableInvMqttData)
              this.disabledEdit = false
              if (this.tableInvMqttData.model) {
                this.inverterTypeArr.forEach(v => {
                  if (this.tableInvMqttData.model == v.value) this.inverterType = v.label
                })
              }
              if (this.tableInvMqttData.batType) this.tableEditObj.batteryType = this.tableInvMqttData.batType.toString()
              if (this.tableInvMqttData.vol_ABS) this.tableEditObj.absV = this.tableInvMqttData.vol_ABS / 100 + ' V'
              if (this.tableInvMqttData.volFloat) this.tableEditObj.floatV = this.tableInvMqttData.volFloat / 100 + ' V'
              if (this.tableInvMqttData.chargeKey) this.tableEditObj.chargeOnOff = this.tableInvMqttData.chargeKey.toString()
              if (this.tableInvMqttData.chargeCurr) this.tableEditObj.chargeA = this.tableInvMqttData.chargeCurr.toString()
              if (this.tableInvMqttData.currFloat) this.tableEditObj.floatA = this.tableInvMqttData.currFloat.toString()
              if (this.tableInvMqttData.rechargeVol) this.tableEditObj.rechargeV = this.tableInvMqttData.rechargeVol / 100 + ' V'
              if (this.tableInvMqttData.bTM) this.tableEditObj.batteryTem = this.tableInvMqttData.bTM.toString()
              if (this.tableInvMqttData.cbr) this.tableEditObj.currentLimit = this.tableInvMqttData.cbr.toString()
              if (this.tableInvMqttData.defaults) this.tableEditObj.reset = this.tableInvMqttData.defaults.toString()
              if (this.tableInvMqttData.batLowVolRst) this.tableEditObj.lowVReset = this.tableInvMqttData.batLowVolRst / 100 + ' V'
              if (this.tableInvMqttData.batLowVolAlarm) this.tableEditObj.lowVWarn = this.tableInvMqttData.batLowVolAlarm / 100 + ' V'
              if (this.tableInvMqttData.batLowVolProtect) this.tableEditObj.lowVProtect = this.tableInvMqttData.batLowVolProtect / 100 + ' V'
              if (this.tableInvMqttData.inverterStatus) this.tableEditObj.inverterStatu = this.tableInvMqttData.inverterStatus.toString()
              if (this.tableInvMqttData.buzzerStatus) this.tableEditObj.buzzerOnOff = this.tableInvMqttData.buzzerStatus.toString()
              if (this.tableInvMqttData.lowPowerMode) this.tableEditObj.savePower = this.tableInvMqttData.lowPowerMode.toString()
              if (this.tableInvMqttData.defaults == 2) { // 1:yes 不展示  2：no 展示
                this.tableEditObj.reset = false
                this.tableDataAll.forEach(v => {
                  v.isShow = true
                })
              } else {
                this.tableEditObj.reset = true
                this.tableDataAll.forEach(v => {
                  v.isShow = false
                  if (v.key == 'inverterType' || v.key == 'reset')v.isShow = true
                })
              }
              var CfgData = {
                // bidBatteryType: this.tableInvMqttData.batType,
                // float: this.tableInvMqttData.currFloat,
                // bulk: this.tableInvMqttData.chargeCurr,
                bidBatteryType: 2,
                float: 3,
                bulk: 2,
                // dcBatteryType: 4,
                // float: 2,
                // bulk: 2,
                dcId: this.tableInvMqttData.inverter_ID
              }
              this.$emit('bidCfgObj', CfgData)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.bag{
  background:#e0e0e085;
}
.card-panel{
  padding-bottom: 20px;
}
#bidSetTem{
  .content{
    // background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .contentWrap {
    background: #27679e;
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    height: 550px;
    width: 100%;
    // background: white;
    padding-top: 20px;
  }
  .middleContentLeft{
    // height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middleContentLeft>div{
    // border:1px solid red;
    // width:100px;
    // height:200px;
  }
  .plugWarp>div:nth-of-type(1){
    display: flex;
    justify-content: center;
  }
  .plugWarp>div:nth-of-type(1) img{
    width: 100px;
    margin-bottom: 10px;
  }
  .plugWarp>div:nth-of-type(2){
    text-align: center;
  }
  .plugWarp>div:nth-of-type(2) img{
    width:30px;
  }
  .plugWarp>div:nth-of-type(2) span{
    line-height: 30px;
    vertical-align: top;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #63bb38;
  }
  .greenDeltaRight{//向右三角形
    width: 0;
    height: 0;
    border-left: 15px solid #63bb38;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
  }
  .acChargeDiv{
    position: relative;
  }
  .acChargeDiv div:first-child p{
    text-align: center;
  }
  .acChargeDiv>div{
    display: inline-block;
  }
  .acChargeDiv .acChargeInfo{
    vertical-align: top;
  }
  .acChargeInfo>div{
    margin-top:40px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -45px;
  }

  .middleContentRight{
    height: 400px;
    // border:1px solid red;
    position: relative;
    padding-left: 20px;
  }
  .middleContentRight>div{
    // border:1px solid red;
    // height:80px;
    position: absolute;
  }
  .arrowOrLine{
    border-top: 3px solid #63bb38;
    border-right: 3px solid #63bb38;
    position: relative;
  }
  .greenDeltaBottom{
    position: absolute;
    bottom: -5px;
    right: -11px;
  }
  .middleContentRight>div:nth-of-type(1){
    width:calc(100% - 100px);
    top: 47px;
    height: 74px;
  }
  .middleContentRight>div:nth-of-type(2){
    width:calc(100% - 280px);
    top: 105px;
    height: 96px;
  }
  .middleContentRight>div:nth-of-type(3){
    width:calc(100% - 460px);
    top: 162px;
    height: 118px;
  }
  .middleContentRight>div:nth-of-type(4){
    right: 0;
    top: 130px;
  }
  .middleContentRight>div:nth-of-type(5){
    right: 180px;
    top: 210px;
  }
  .middleContentRight>div:nth-of-type(6){
    right: 360px;
    top: 290px;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  .cellTeamBoxImg{
    display: flex;
    justify-content: center;
  }
  .cellTeamBox>img{
    width: 160px;
  }
  .cellTeamBoxInfo{
    text-align: center;
  }
  .cellTeamBoxInfo img{
    width:30px;
  }
  .cellTeamBoxInfo span{
    line-height: 30px;
    vertical-align: top;
  }
  .dottedLine{
   border-top: 3px dotted #e3e3e3;
   border-right: 3px dotted #e3e3e3;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    // color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
  .acChargeWarp{
    padding:0 5%;
  }
  // .acChargeDiv{
  //   position: relative;
  // }
  .acChargeImg{
    width:150px;
    // border:1px solid red;
  }
}
</style>
<style lang="scss">
#bidSetTem{
  .btnSpace{
    height: 40px;
    border: 1px solid #537ba3;
    border-bottom: none;
  }
  .el-radio {
    color: #fff;
  }
  .el-switch__label.is-active {
    color: #1990fc;
  }
  .el-switch__label {
    color: #ffffff;
  }
}
</style>

